import './src/styles/global.css'

import React from 'react';
import BownowContext from './src/contexts/BownowContext';

// !!set bownow id here!! it's passed to contact component by Context API
const BowNowId = {
  ts: 'UTC_2e40f188133d5e94db53',
  cs: 'sid_1be068f99ec7bfa59b45',
}

export const wrapRootElement = ({ element }) => {
  return (
    <BownowContext.Provider value={{ BownowId: BowNowId }}>
      {element}
    </BownowContext.Provider>
  );
};

//bownow form script
const onRouteUpdate = () => {
  const scriptTs = `https://contents.bownow.jp/js/${BowNowId.ts}/trace.js`;
  const scriptCs = `https://contents.bownow.jp/forms/${BowNowId.cs}/trace.js`;

  // Check if scripts already exist to avoid redundant injection
  const existingTs = document.querySelector(`script[src="${scriptTs}"]`);
  const existingCs = document.querySelector(`script[src="${scriptCs}"]`);

  if (!existingTs) {
    const _bownow_ts = document.createElement('script');
    _bownow_ts.charset = 'utf-8';
    _bownow_ts.src = scriptTs;
    _bownow_ts.async = true;
    document.getElementsByTagName('head')[0].appendChild(_bownow_ts);
  }

  if (!existingCs) {
    const _bownow_cs = document.createElement('script');
    _bownow_cs.charset = 'utf-8';
    _bownow_cs.src = scriptCs;
    _bownow_cs.async = true;
    document.getElementsByTagName('head')[0].appendChild(_bownow_cs);
  }
};

export { onRouteUpdate };
